import { Injectable } from "@angular/core";

/**
 * Utility that owns the nearest-draw-day resolution previously implemented as
 * `checkNearestDay` on `ProductComponent`. The host component instance is passed
 * in so the selection side effects (`selectDrawday`, `drawCloseTime`) stay
 * identical to the original behaviour.
 */
@Injectable()
export class ProductDrawDayUtility {
  // this function is used to compare the current day with the draw day and set the closest draw day with the isSelected flag to true.
  // This function is used to check the nearest draw day and set the isSelected flag to true.
  checkNearestDay(host: any, draw_days: any) {
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let curDay = new Date().getDay();
    let draw_Days_index = [draw_days?.length];
    let temp = [draw_days?.length]; //for storing distance
    let temp1 = -1;
    let count = 0;
    draw_days?.forEach((element) => {
      draw_Days_index[count] = days?.indexOf(element["draw_day"]);
      count++;
    });

    for (let i = 0; i < count; i++) {
      temp1 = 0;
      //calculate distance
      for (let j = curDay; j <= 7; j++) {
        if (temp1 < 7 && j == 7) {
          j = 0;
        }
        if (j == draw_Days_index[i]) {
          if (temp1 == 0 && host.drawCloseTime < 0) temp[i] = 8;
          else temp[i] = temp1;
          j = 7;
        }
        temp1++;
      }
    }
    //check closest one
    let closest = 8;
    let closestIndex = 0;
    for (let i = 0; i < temp?.length; i++) {
      if (closest > temp[i]) {
        closest = temp[i];
        closestIndex = i;
      }
    }
    let k = 0;
    for (let j = 0; j < draw_days?.length; j++) {
      if (closestIndex == j) {
        draw_days[j]["isSelected"] = true;
        host.selectDrawday(draw_days[j], draw_days, j);
      } else {
        draw_days[j]["isSelected"] = false;
      }
    }
    return draw_days;
  }

  // Selects or deselects a draw day in the draw day dropdown
  selectDrawday(host: any, day, draw_days, index): void {
    if (!day?.isSelected) {
      day.isSelected = !day?.isSelected;
    } else {
      let selectedCount = 0;
      draw_days.forEach((data) => {
        if (data?.isSelected) {
          selectedCount++;
        }
      });
      if (!(selectedCount === 1 && draw_days[index]?.isSelected)) {
        day.isSelected = !day?.isSelected;
      }
    }
    host.drawDay$.next([]);
    let drawDay = [];
    drawDay = draw_days.filter((data) => data?.isSelected);
    drawDay.forEach((data) => {
      host.drawDay$.next([...host.drawDay$.value, data?.draw_day]);
    });
  }
}
